/**
 * Created by ebeltramo on 30/07/2019.
 */
angular
    .module('annexaApp')
    .controller('roleInterestedDossierController', [function() {
    	//Empty
    }]);